/**
 * Erzeugt einen UI-Lock. Nützlich, um Teile der Oberfläche und zugehörige Funktionen über einen gemeinsamen
 * Sperr-Zustand auf aktiv / inaktiv zu setzen.
 */
class UILock {


    /**
     * callback wird bei jeder Zustandsänderung des Locks aufgerufen mit dem Sperrflag aufgerufen
     */
    constructor(callback) {
        this.callback = callback;
        this.locked = false;
        this.disableElements = [];
    }

    /**
     * isLocked
     */
    isLocked() {
        return this.locked;
    }

    /**
     * setLocked
     */
    setLocked(lock) {
        this.locked = lock;
        this.disableElements.forEach(disable => {
            if (this.locked) {
                disable.addClass('disabled')
            } else {
                disable.removeClass('disabled')
            }
        })
        if (this.callback) {
            this.callback(this.locked);
        }

    }

    /**
     * Abhängig von der Sperre wird dem übergebenen UI-Element die HTML-Klasse "disabled" hinzugefügt oder genommen.
     */
    disableWhenLocked(disableElement) {
        this.disableElements.push($(disableElement));
        return disableElement;
    }

    /**
     * Wrapped die Funktion eventCallback. Sie gibt ihren Aufruf nur weiter, wenn der Lock nicht gesperrt ist.
     * Optional kann ein UI-Element zum Lock hinzugefügt werden.
     */
    wrap(eventCallback, disableElement) {
        if (typeof disableElement !== 'undefined') {
            this.disableElements.push($(disableElement));
        }
        return (...args) => {
            if (this.locked) {
                return;
            }
            return eventCallback.apply(this, args);
        }
    }

}

export default UILock;

